
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-forcer-mdp-dialog',
    templateUrl: './confirmation-forcer-mdp-dialog.component.html',
    styleUrls: ['./confirmation-forcer-mdp-dialog.component.scss'],
    imports: [TranslateModule]
})
export class ConfirmationForcerMdpDialogComponent implements OnInit {
  email: string;
  password: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { email: string, password: string },
    private dialogRef: MatDialogRef<ConfirmationForcerMdpDialogComponent>
  ) {
    this.email = data.email;
    this.password = data.password;
  }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
